<template>
  <div>
    <transition name="fade-grafico-rede" mode="out-in">
      <div v-if="!loading">
        <unicom-icone
          class="icone-grafico-rede"
          nome="pie-chart"
          :tamanho="25"
        />
        <div class="fonte-primaria" style="margin: 0px !important">
          <div id="container">
            <highcharts
              ref="grafico"
              :options="chartOptions"
              :callback="graficoCarregado"
            ></highcharts>
          </div>
        </div>
      </div>
      <CarregandoTipoRede v-if="loading" />
    </transition>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import CarregandoTipoRede from "./CarregandoTipoRede";
import GraficoMixin from "../GraficoMixin";

export default {
  components: {
    highcharts: Chart,
    CarregandoTipoRede
  },
  mixins: [GraficoMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },

    arrayGrafico: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    enumTipoRede() {
      return {
        BASICA: {
          color: "rgb(0,153,93)",
          corDesativada: "rgb(0,153,93,0.2)"
        },
        ESPECIAL: {
          color: "rgb(177,211,75)",
          corDesativada: "rgb(177,211,75,0.2)"
        },
        MASTER: {
          color: "rgb(237,22,81)",
          corDesativada: "rgb(237,22,81,0.2)"
        }
      };
    }
  },
  watch: {
    arrayGrafico: {
      deep: true,
      immediate: true,
      handler() {
        this.atualizarDados();
      }
    }
  },
  mounted() {
    // Dependendo da classe que o item tem, ele troca a cor do simbolo na legenda
    Highcharts.addEvent(Highcharts.Legend, "afterColorizeItem", e => {
      const nomeClasse = e.item.className;
      const contemClasseDesativada = nomeClasse === "point-rede-desativado";
      const contemClasseAtiva = nomeClasse === "point-rede-ativado";

      if (contemClasseDesativada) {
        e.item.legendSymbol.attr({
          fill: e.item.options.corDesativada
        });
      } else if (contemClasseAtiva) {
        e.item.legendSymbol.attr({
          fill: e.item.options.color
        });
      }
    });
  },
  methods: {
    atualizarDados() {
      const dados = this.arrayGrafico.map(e => {
        const {
          quantidade,
          tipo: { chave, descricao }
        } = e;

        return {
          y: quantidade === 0 ? null : quantidade,
          quantidade,
          name: descricao,
          chave,
          ...this.enumTipoRede[chave]
        };
      });

      this.$set(this.chartOptions.series[0], "data", dados);
    },

    /**
     * Função que é chamada logo após o clique, tanto no gráfico quanto na legenda
     * @param { String } chave
     */
    selecionarChave(chave) {
      if (this.chaveSelecionada === chave && this.dadosDesativados) {
        this.$emit("remove-filtro", {
          chaveRemocao: "tipoRede",
          sucesso: () => this.ativarDados()
        });
        return;
      } else if (this.dadosDesativados) {
        return;
      }

      this.$emit("adiciona-filtro", {
        chaveAdicao: "tipoRede",
        value: chave,
        sucesso: () => this.desativarDados(chave)
      });
    },
    /**
     * Desativa todas as legendas e points que são diferentes da chave selecionada
     * @param { String } chave
     */
    desativarDados(chave) {
      this.dadosDesativados = true;
      this.chaveSelecionada = chave;

      this.graficoRef.series[0].data.forEach(e => {
        const { chave: chaveAtual } = e.options;
        if (chaveAtual !== chave) {
          e.update(
            {
              className: "point-rede-desativado"
            },
            false
          );
        }
      });
      this.graficoRef.redraw();
    },
    /**
     * Ativa todas as legendas e points
     */
    ativarDados() {
      this.dadosDesativados = false;
      this.chaveSelecionada = null;

      this.graficoRef.series[0].data.forEach(e => {
        e.update({ className: "point-rede-ativado" }, false);
      });

      this.graficoRef.redraw();
    }
  },
  data() {
    return {
      graficoRef: null,
      chartOptions: {
        chart: {
          renderTo: "container",
          type: "pie",
          height: "218px"
        },
        plotOptions: {
          pie: {
            size: "90%",
            innerSize: "100%",
            borderWidth: 4,
            allowPointSelect: true,
            cursor: "pointer"
          }
        },
        title: {
          text: "Tipo de rede",
          floating: true,
          align: "left",
          x: 40,
          style: {
            fontWeight: "bold",
            fontFamily: "Unimed Slab",
            color: "#60656C",
            fontSize: 21
          }
        },

        credits: {
          enabled: false
        },

        legend: {
          floating: true,
          width: 280,
          verticalAlign: "middle",
          itemStyle: {
            fontWeight: "normal",
            fontFamily: "Trebuchet MS",
            textAlign: "center",
            fontSize: 14
          },
          layout: "vertical",
          align: "left",
          symbolRadius: 4,
          itemMarginTop: 0,
          itemMarginBottom: 20,
          symbolHeight: 14,
          symbolPadding: 12,
          useHTML: true,
          labelFormatter: function() {
            const {
              name,
              className,
              options: { quantidade }
            } = this;

            const contemClasseDesativada =
              className === "point-rede-desativado";

            return `<div class="cor-fonte medio ${
              contemClasseDesativada ? "tipo-rede-desativado" : ""
            }"> ${name} <span class="segunda-cor-fonte"> ${Highcharts.numberFormat(
              quantidade,
              0,
              ".",
              "."
            )} </span> </div>`;
          }
        },

        series: [
          {
            center: ["70%", "45%"],
            className: "serie-tipo-rede",
            name: "PTU",
            data: [],

            innerSize: "55%",
            showInLegend: true,
            allowPointSelect: false,
            point: {
              events: {
                click: ev => {
                  const { chave } = ev.point.options;

                  this.selecionarChave(chave);

                  return ev.preventDefault();
                },
                legendItemClick: ev => {
                  const { chave } = ev.target.options;

                  this.selecionarChave(chave);

                  return ev.preventDefault();
                },
                remove: () => {
                  return false;
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function() {
                const porcentagemFormatado = Highcharts.numberFormat(
                  this.percentage,
                  2
                );
                // if (parseInt(porcentagemFormatado) === 0) return null;
                return porcentagemFormatado + "%";
              },
              connectorShape: "straight",
              distance: 30,
              style: {
                fontWeight: "bold",
                color: "#60656C",
                textOutline: 0
              }
            },
            states: {
              hover: {
                halo: {
                  size: 0
                }
              }
            }
          }
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 400
              },
              chartOptions: {
                legend: {
                  align: "left",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                  floating: false
                },
                chart: {
                  height: "500px"
                },
                series: [
                  {
                    center: [null, "55%"]
                  }
                ]
              }
            }
          ]
        }
      }
    };
  }
};
</script>

<style lang="scss">
.point-rede-desativado {
  cursor: not-allowed !important;
}

.tipo-rede-desativado {
  cursor: not-allowed;
}

.icone-grafico-rede {
  color: #00995d;
  position: absolute;
  z-index: 1;
  left: 31px;
  top: 6px;
}

.serie-tipo-rede > .highcharts-point-inactive {
  cursor: not-allowed !important;
  opacity: 0.2;
}

.highcharts-legend-item > span {
  top: 0px !important;
}

.fade-grafico-rede-enter-active,
.fade-grafico-rede-leave,
.fade-grafico-rede-leave-to {
  transition: opacity 0.25s ease;
}

.fade-grafico-rede-enter,
.fade-grafico-rede-leave-to {
  opacity: 0;
}
</style>
